import { ClinicalImpression } from "@medplum/fhirtypes";

import {
  getCodeableConceptCode,
  getCodeableConceptDisplay,
  getCodeableConceptSystem,
} from "@/utils/medplum";

/**
 * Extracts key and nested data from a ClinicalImpression object.
 * @param {Object} clinicalImpression - The ClinicalImpression object.
 * @returns {Object} An object containing the extracted data.
 */
export function getClinicalImpressionData(clinicalImpression: ClinicalImpression) {
  return {
    assessorDisplay: clinicalImpression?.assessor?.display || "",
    assessorId: clinicalImpression?.assessor?.reference?.split("/")[1] || "",
    assessorReference: clinicalImpression?.assessor?.reference || "",
    authorDisplay: clinicalImpression?.meta?.author?.display || "",
    authorId: clinicalImpression?.meta?.author?.reference?.split("/")[1] || "",
    authorReference: clinicalImpression?.meta?.author?.reference || "",
    code: getCodeableConceptCode(clinicalImpression?.code),
    date: clinicalImpression?.date || "",
    display: getCodeableConceptDisplay(clinicalImpression?.code),
    findingCode: getCodeableConceptCode(clinicalImpression?.finding?.[0]?.itemCodeableConcept),
    id: clinicalImpression?.id || "",
    lastUpdated: clinicalImpression?.meta?.lastUpdated || "",
    projectId: clinicalImpression?.meta?.project || "",
    questionnaireResponseId:
      clinicalImpression?.supportingInfo?.[0]?.reference?.split("/")[1] || "",
    questionnaireResponseReference: clinicalImpression?.supportingInfo?.[0]?.reference || "",
    resourceType: clinicalImpression?.resourceType || "",
    status: clinicalImpression?.status || "",
    subjectId: clinicalImpression?.subject?.reference?.split("/")[1] || "",
    subjectReference: clinicalImpression?.subject?.reference || "",
    summary: clinicalImpression?.summary || "",
    system: getCodeableConceptSystem(clinicalImpression?.code),
    versionId: clinicalImpression?.meta?.versionId || "",
  };
}
